import React, { useEffect, useState } from "react";
import "./nav.css";
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { BiBook, BiMessageSquareDetail } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";

const sectionsOrder = ["#", "about", "experience", "portfolio", "contact"];

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");

  useEffect(() => {
    const ids = sectionsOrder
      .filter((id) => id !== "#")
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    // Observa entrada/saída de cada seção na viewport
    const observer = new IntersectionObserver(
      (entries) => {
        // pega a seção que está mais "visível"
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible?.target?.id) {
          setActiveNav(`#${visible.target.id}`);
        } else {
          // fallback: se nenhuma seção específica está visível, considere o topo (home)
          const scrollY = window.scrollY || window.pageYOffset;
          if (scrollY < 100) setActiveNav("#");
        }
      },
      {
        // ajuste se tiver header fixo (ex.: 72px de altura): "-72px 0px -40% 0px"
        root: null,
        threshold: [0.25, 0.5, 0.75],
        rootMargin: "0px 0px -40% 0px", // considera a seção ativa quando ~60% visível
      }
    );

    ids.forEach((el) => observer.observe(el));
    // ativa "home" no topo
    const onScrollTop = () => {
      if (window.scrollY < 100) setActiveNav("#");
    };
    window.addEventListener("scroll", onScrollTop, { passive: true });

    return () => {
      ids.forEach((el) => observer.unobserve(el));
      observer.disconnect();
      window.removeEventListener("scroll", onScrollTop);
    };
  }, []);

  return (
    <nav>
      <a
        href="#"
        onClick={() => setActiveNav("#")}
        className={activeNav === "#" ? "active" : ""}
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav("#about")}
        className={activeNav === "#about" ? "active" : ""}
      >
        <AiOutlineUser />
      </a>
      <a
        href="#experience"
        onClick={() => setActiveNav("#experience")}
        className={activeNav === "#experience" ? "active" : ""}
      >
        <BiBook />
      </a>
      <a
        href="#portfolio"
        onClick={() => setActiveNav("#portfolio")}
        className={activeNav === "#portfolio" ? "active" : ""}
      >
        <RiServiceLine />
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav === "#contact" ? "active" : ""}
      >
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default Nav;
